// extracted by mini-css-extract-plugin
export var cardDetails = "Grid-module__cardDetails___gfdpn";
export var cardImage = "Grid-module__cardImage___jInFd";
export var content = "Grid-module__content___CwvCa";
export var grid = "Grid-module__grid___OXd9O";
export var lesson = "Grid-module__lesson___Ev7wP";
export var lessonList = "Grid-module__lessonList___hOjYG";
export var postCard = "Grid-module__postCard___IuMvi";
export var section = "Grid-module__section___zGYww";
export var spotlight = "Grid-module__spotlight___fbpql";
export var spotlightContent = "Grid-module__spotlightContent___a40-W";
export var spotlightImage = "Grid-module__spotlightImage___pED1c";
export var spotlightOuter = "Grid-module__spotlightOuter___CaEkj";